// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-select-dropdown__item.selected[data-v-22e88720]{font-weight:400;color:#606266}.albums[data-v-22e88720],.drop[data-v-22e88720]{cursor:move}.albums[data-v-22e88720]{float:left;margin-right:10px;position:relative}.ab[data-v-22e88720]{position:absolute;right:-5px;top:-5px}.ab[data-v-22e88720],.re[data-v-22e88720]{color:#f60;cursor:pointer;font-size:20px;background:#fff;border-radius:50%}.re[data-v-22e88720]{margin-left:20px}", ""]);
// Exports
module.exports = exports;
